import ComingSoon from "components/ComingSoon";
import React from "react";

function Campaign() {
  return <ComingSoon />;
}

export default Campaign;
